import { Archive, Clock, Shield, type LucideIcon } from "lucide-react";

export type BuiltInTrackerType = "warranty" | "lead_time" | "attic_stock";

export interface TrackerCounts {
  warranty: number;
  lead_time: number;
  attic_stock: number;
}

export interface CustomTrackerInfo {
  name: string;
  count: number;
}

export const BUILT_IN_TRACKERS: Array<{
  type: BuiltInTrackerType;
  label: string;
  shortLabel: string;
  summaryLabel: string;
  icon?: LucideIcon;
}> = [
  {
    type: "warranty",
    label: "Warranty",
    shortLabel: "Warranty",
    summaryLabel: "Warranty Tracker",
    icon: Shield,
  },
  {
    type: "lead_time",
    label: "Lead Time",
    shortLabel: "Lead",
    summaryLabel: "Lead Time Tracker",
    icon: Clock,
  },
  {
    type: "attic_stock",
    label: "Attic Stock",
    shortLabel: "Attic",
    summaryLabel: "Attic Stock Tracker",
    icon: Archive,
  },
];
